import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';
import { displayError } from '@/utils/functions/displayError';

import type { CreateLeadRequestBody, CreateLeadRequestResponse } from './types';

type CreateLeadParams = {
  payload: CreateLeadRequestBody;
  leadVersion: 'v0' | 'v1';
};

const createLead = ({
  payload,
  leadVersion,
}: CreateLeadParams): Promise<
  BaseResponse<CreateLeadRequestResponse, CreateLeadRequestBody>
> => {
  const url = leadVersion === 'v1' ? '/fx/v1/leads' : '/fx/leads';
  return axios<
    CreateLeadRequestBody,
    BaseResponse<CreateLeadRequestResponse, CreateLeadRequestBody>,
    CreateLeadRequestBody
  >({
    url,
    method: 'post',
    data: {
      ...payload,
    },
  });
};

export const useCreateLead = () => {
  const { mutateAsync, error, isSuccess } = useMutation({
    mutationFn: createLead,
  });

  useEffect(() => {
    displayError(error);
  }, [error]);

  return { createLead: mutateAsync, isSuccess };
};
